<template>
  <b-card
    no-body
    class="shadow-sm border-0"
  >
    <b-card-header class="pb-0">
      <b-card-title class="font-medium-2">
        <feather-icon
          icon="AlertCircleIcon"
          class="mr-50 text-warning"
        />
        {{ title }}
      </b-card-title>
    </b-card-header>

    <b-card-body class="p-0">
      <b-table
        responsive
        hover
        :items="tableItems"
        :fields="fields"
        class="mb-0"
        show-empty
        empty-text="No items require restocking"
        thead-class="bg-light"
        :busy="loading"
      >
        <template #table-busy>
          <b-skeleton-table
            :rows="5"
            :columns="fields.length"
            :table-props="{ striped: true }"
          />
        </template>

        <template #cell(current_stock)="row">
          <b-badge
            pill
            :variant="row.item.current_stock <= row.item.min_stock ? 'light-danger' : 'light-success'"
          >
            {{ row.value }}
          </b-badge>
        </template>

        <template #cell(min_stock)="row">
          <span class="font-weight-bold text-secondary">
            {{ row.value }}
          </span>
        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BTable,
  BBadge,
  BSkeletonTable,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BTable,
    BBadge,
    BSkeletonTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Table Data',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableItems() {
      if (!this.data || this.data.length <= 1) return []

      return this.data.slice(1).map(row => ({
        no: row[0],
        item_name: row[1],
        item_code: row[2],
        current_stock: row[3],
        min_stock: row[4],
      }))
    },
    fields() {
      return [
        { key: 'no', label: '#', sortable: true },
        { key: 'item_name', label: 'Item Name', sortable: true },
        { key: 'item_code', label: 'Code' },
        {
          key: 'current_stock',
          label: 'Stock',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'min_stock',
          label: 'Min',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.b-table {
  font-size: 0.9rem;
}

@media (max-width: 640px) {
  .b-table {
    font-size: 0.8rem;
  }
}
</style>